;(function() {
  'use strict'

  wordCloudWordsFilter.$inject = ["stopCloudWords"];
  angular
    .module('core.filters')
    /**
     * @name stopWords
     * @description list of words that should not be used for word cloud
     */
    .constant('stopCloudWords', [
      'a',
      'able',
      'about',
      'across',
      'after',
      'all',
      'almost',
      'also',
      'am',
      'among',
      'an',
      'and',
      'any',
      'are',
      'as',
      'at',
      'be',
      'because',
      'been',
      'but',
      'by',
      'can',
      'cannot',
      'could',
      'dear',
      'did',
      'do',
      'does',
      'either',
      'else',
      'ever',
      'every',
      'for',
      'from',
      'get',
      'got',
      'had',
      'has',
      'have',
      'he',
      'her',
      'hers',
      'him',
      'his',
      'how',
      'however',
      'i',
      'if',
      'in',
      'into',
      'is',
      'it',
      'its',
      'just',
      'least',
      'let',
      'like',
      'likely',
      'may',
      'me',
      'might',
      'most',
      'must',
      'my',
      'neither',
      'no',
      'nor',
      'not',
      'of',
      'off',
      'often',
      'on',
      'only',
      'or',
      'other',
      'our',
      'own',
      'rather',
      'said',
      'say',
      'says',
      'she',
      'should',
      'since',
      'so',
      'some',
      'than',
      'that',
      'the',
      'their',
      'them',
      'then',
      'there',
      'these',
      'they',
      'this',
      'tis',
      'to',
      'too',
      'twas',
      'us',
      'wants',
      'was',
      'we',
      'were',
      'what',
      'when',
      'where',
      'which',
      'while',
      'who',
      'whom',
      'why',
      'will',
      'with',
      'would',
      'yet',
      'you',
      'your',
      'not-asked',
    ])
    .filter('wordCloudWords', wordCloudWordsFilter)

  /**
   * @name wordCloudWordsFilter
   * @description filters words that should not be displayed in the word cloud
   *
   * @param {Array} stopCloudWords array of interactions
   * @returns {Object} array of unique words with their respective word count
   *
   * @ngInject
   */
  function wordCloudWordsFilter(stopCloudWords) {
    return function(input, limit, ignoreWords, questionId) {
      limit = limit || 50

      var stopWordsHash = {}
      var output

      // add ignore words to stop words
      stopCloudWords = stopCloudWords.concat(ignoreWords)

      // parse stopwords to associative-array / hash object for O(1) lookup
      for (var i = 0, len = stopCloudWords.length; i < len; i++) {
        stopWordsHash[stopCloudWords[i]] = true
      }

      // convert to array
      output = _.map(input, function(value, key) {
        var word = {}
        word[questionId] = value.count
        word.word = key
        word.total = value.count
        return word
      })

      // filter out the unwanted words
      output = _.filter(output, function(o) {
        return !stopWordsHash[o.word]
      })

      // sort and limit
      output = _.sortBy(output, function(word) {
        return -word.total
      }).slice(0, limit)

      return output
    }
  }
})()
